import { enableAgentHelpButton } from '@gonfalon/dogfood-flags/dogfood-flags';

import { AgentHelpButton } from './AgentHelpButton';

export function AgentDrawerHelpButton({ docsPath }: { docsPath?: string }) {
  return enableAgentHelpButton() ? <AgentHelpButton docsPath={docsPath} /> : null;
}
